<script>
  import {getContext} from 'svelte';
  import {LINKS} from '@/const/link';
  import {PATHS} from '@/const/paths';
  import {sd} from '@/da';
  import {fixLink$} from '@/store/lang';
  import MenuItemView from '../components/MenuItemView.svelte';
  import lang from '../../Header.lang';

  const LG = getContext('LG');
  function handleLearnClickFuc(item) {
    return function () {
      sd.track('web_click', {$screen_name: 'home', $element_content: 'navigation_learn_' + item});
    };
  }
</script>

<style>
  .wrap {
    box-sizing: border-box;
    padding: 16px;
    width: 328px;
    background: rgba(26, 29, 31, 0.96);
    backdrop-filter: blur(10px);
    cursor: default;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
</style>

<div class="wrap df fdc T2 ovh">
  <MenuItemView
    theme="dark"
    iconUrl="https://img.phemex.com/v1/7c052fca-725c-4007-a496-fa8df58fb232/property-1-academy.svg"
    iconAlt="academy"
    link={$fixLink$(LINKS.PHEMEX_ACADEMY, 'CMS')}
    target="_self"
    title={LG(lang.Academy)}
    subTitle={LG(lang.LearnEverythingAboutCrypto)}
    on:click={handleLearnClickFuc('academy')}
    noArrow
  />
  <MenuItemView
    theme="dark"
    iconUrl="https://img.phemex.com/v1/d8370c4e-cb0d-48b9-8914-941ab7d4caf2/property-1-learn-and-earn.svg"
    iconAlt="learn_and_earn"
    link={$fixLink$(PATHS.LEARN_CRYPTO.pathname)}
    target="_self"
    title={LG(lang.LearnAndEarn)}
    subTitle={LG(lang.GetPaidToLearnCrypto)}
    on:click={handleLearnClickFuc('learn_and_earn')}
    noArrow
  >
    <span class="ml4" slot="title-suffix" />
  </MenuItemView>
  <MenuItemView
    theme="dark"
    iconUrl="https://img.phemex.com/v1/ab3834bc-6106-43f9-a6cf-234d8925c700/property-1-help-center.svg"
    iconAlt="user_guides"
    link={$fixLink$(LINKS.PHEMEX_HELP_CENTER, 'CMS')}
    target="_self"
    title={LG(lang.HelpCenter)}
    subTitle={LG(lang.FAQHelp)}
    on:click={handleLearnClickFuc('user_guides')}
    noArrow
  />
  <MenuItemView
    theme="dark"
    iconUrl="https://img.phemex.com/v1/3f887497-bbbe-459f-9e77-5f6cd6b5770d/property-1-blog.svg"
    iconAlt="blog"
    link={$fixLink$(LINKS.PHEMEX_BLOG, 'CMS')}
    target="_self"
    title={LG(lang.Blog)}
    subTitle={LG(lang.CryptoTipsAndTrick)}
    on:click={handleLearnClickFuc('blog')}
    noArrow
  />
  <MenuItemView
    theme="dark"
    iconUrl="https://img.phemex.com/v1/aba49f45-e646-4363-a0f2-ad3cb77a3a7e/property-1-student-founduation.svg"
    iconAlt="student_foundation"
    link={$fixLink$(PATHS.STUDENT_FOUNDATION.pathname)}
    target="_self"
    title={LG(lang.StudentFoundation)}
    subTitle={LG(lang.EmpowerStudent)}
    on:click={handleLearnClickFuc('student_foundation')}
    noArrow
  />
  <MenuItemView
    theme="dark"
    iconUrl="https://img.phemex.com/v1/de2a4dc5-1ab9-46d0-96a7-3db81e0f6c17/property-1-simulate-trading.svg"
    link={LINKS.PHEMEX_TESTNET}
    target="_self"
    title={LG(lang.LearnSimulatedTrading)}
    subTitle={LG(lang.LearnHowToTradeWithZeroRisk)}
    on:click={handleLearnClickFuc('simulated_trading')}
    noArrow
  />
</div>
